import { render, staticRenderFns } from "./InteractionsSidebar.vue?vue&type=template&id=45d62ef9&scoped=true"
import script from "./InteractionsSidebar.vue?vue&type=script&lang=js"
export * from "./InteractionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./InteractionsSidebar.vue?vue&type=style&index=0&id=45d62ef9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d62ef9",
  null
  
)

export default component.exports